import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Sync = createSvgIcon(
  <path d="M0 4.5 3.375 0 6.75 4.5H4.5v15H15v2.25H2.25V4.5H0Zm17.25 15h2.25v-15H9V2.25h12.75V19.5H24L20.625 24l-3.375-4.5Z" />,
  'Sync'
);

export { Sync };